import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

const SegmentDescription = (props) => {
  return (
    <>
      <Modal
        show={props.showModalVisualization}
        onHide={() => props.setShowModalVisualization(false)}
        size="lg"
      >
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>{"Descripción del segmento"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="3" className="pl-4">
                Nombre del segmento:
              </Form.Label>
              <Col sm="12" md="9">
                <Form.Control
                  name="nombre"
                  type="text"
                  defaultValue={props.viewItem ? props.viewItem.nombre : ""}
                  className="rounded-pill"
                  readOnly
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras,numeros y los siguientes caracteres
                  @$¿?¡\-_%#
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group controlId="empleado">
              <Form.Label className="ml-2">Colaboradores:</Form.Label>
              <Form.Control
                as="textarea"
                name="empleado"
                readOnly
                defaultValue={
                  props.viewItem
                    ? props.viewItem.empleados_list
                      ? props.viewItem.empleados_list.map((item, index) => {
                          return `${index === 0 ? "" : " "}${item.codigo} ${
                            item.nombre
                          }`;
                        })
                      : "No tiene"
                    : null
                }
                pattern="[A-Za-z0-9]+"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite números y letras
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="Empresas">
              <Form.Label className="ml-2">Organizaciones:</Form.Label>
              <Form.Control
                as="textarea"
                name="Empresas"
                readOnly
                defaultValue={
                  props.viewItem
                    ? props.viewItem.empresas_list
                      ? props.viewItem.empresas_list.map((item, index) => {
                          return `${index === 0 ? "" : " "}${item.nombre}`;
                        })
                      : "No tiene"
                    : null
                }
                pattern="[A-Za-z0-9]+"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite números y letras
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="unidades">
              <Form.Label className="ml-2">Unidades organizativas:</Form.Label>
              <Form.Control
                as="textarea"
                name="unidades"
                readOnly
                defaultValue={
                  props.viewItem
                    ? props.viewItem.unidades_list
                      ? props.viewItem.unidades_list.map((item, index) => {
                          return `${index === 0 ? "" : " "}${item.nombre}`;
                        })
                      : "No tiene"
                    : null
                }
                pattern="[A-Za-z0-9]+"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite números y letras
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="puestos">
              <Form.Label className="ml-2">Puestos:</Form.Label>
              <Form.Control
                as="textarea"
                name="puestos"
                readOnly
                defaultValue={
                  props.viewItem
                    ? props.viewItem.puestos_list
                      ? props.viewItem.puestos_list.map((item, index) => {
                          return `${index === 0 ? "" : " "}${
                            item.descripcion_larga
                          }`;
                        })
                      : "No tiene"
                    : null
                }
                pattern="[A-Za-z0-9]+"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite números y letras
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="generoView">
              <Form.Label className="ml-2">Genero</Form.Label>
              <Form.Control
                as="textarea"
                name="generoView"
                readOnly
                defaultValue={
                  props.viewItem && props.viewItem.genero
                    ? props.viewItem.genero
                    : "Indiferente"
                }
                pattern="[A-Za-z0-9]+"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite números y letras
              </Form.Control.Feedback>
            </Form.Group>
            <Row>
              <Form.Group as={Col} controlId="edad">
                <Row>
                  <Col sm="6" md="6" lg="6" xl="6">
                    <Form.Label className="ml-2">Edad inicio:</Form.Label>
                    <Form.Control
                      name="edadInicio"
                      className="rounded-pill"
                      readOnly
                      type="number"
                      defaultValue={
                        props.viewItem ? props.viewItem.edad_inicio : null
                      }
                      placeholder="0"
                    ></Form.Control>
                  </Col>
                  <Col sm="6" md="6" lg="6" xl="6">
                    <Form.Label className="ml-2">Edad fin:</Form.Label>
                    <Form.Control
                      name="edadFin"
                      className="rounded-pill"
                      readOnly
                      type="number"
                      defaultValue={
                        props.viewItem ? props.viewItem.edad_fin : null
                      }
                      placeholder="0"
                    ></Form.Control>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="antiguedad">
                <Row>
                  <Col sm="6" md="6" lg="6" xl="6">
                    <Form.Label className="ml-2">Antiguedad inicio:</Form.Label>
                    <Form.Control
                      name="antiguedadInicio"
                      className="rounded-pill"
                      readOnly
                      type="number"
                      defaultValue={
                        props.viewItem ? props.viewItem.antiguedad_inicio : null
                      }
                      placeholder="0"
                    ></Form.Control>
                  </Col>
                  <Col sm="6" md="6" lg="6" xl="6">
                    <Form.Label className="ml-2">Antiguedad fin:</Form.Label>
                    <Form.Control
                      name="antiguedadFin"
                      className="rounded-pill"
                      readOnly
                      type="number"
                      defaultValue={
                        props.viewItem ? props.viewItem.antiguedad_fin : null
                      }
                      placeholder="0"
                    ></Form.Control>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => props.setShowModalVisualization(false)}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default SegmentDescription;
